import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { ConfigApiService, ErrorType, catchAppError } from '@core/api';

import { configApiActions } from '../actions/config.actions';

@Injectable()
export class ConfigEffects {
  private actions$ = inject(Actions);
  private configApi = inject(ConfigApiService);

  refreshDataLayers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configApiActions.refreshDataLayers),
      switchMap(() =>
        this.configApi.getLayers().pipe(
          map(({ basemaps, layers }) => configApiActions.refreshDataLayersSuccess({ basemaps, layers })),
          catchAppError((error) => configApiActions.refreshDataLayersFail({ error }), ErrorType.ACTION)
        )
      )
    )
  );
}
